const qs = require("qs");
import axios from "../axios";

// state
const state = {
    user: null,

    token: {},
    scope: `openid profile`, // https://developers.line.biz/en/docs/line-login/integrate-line-login/#scopes
};

// getters
const getters = {
    user: (state) => state.user,
    token: (state) => state.token,
    scope: (state) => state.scope,
};

// mutations
const mutations = {
    SET_USER(state, user) {
        state.user = user;
    },

    SET_TOKEN(state, token) {
        state.token = token;
    },
};

// actions
const actions = {
    // set user
    async setUser({ commit }, user) {
        commit("SET_USER", user);
    },

    // set token
    async setToken({ commit }, token) {
        commit("SET_TOKEN", token);
    },

    // getProfile
    async getProfile({ state, commit }) {
        return await axios({
            method: "GET",
            url: "https://api.line.me/v2/profile",
            headers: {
                Authorization: `Bearer ${state.token.access_token}`,
            },
        });
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};
